import PropTypes from 'prop-types';

export const NestedCheckboxTreeNodePropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  extendable: PropTypes.bool.isRequired,
});

NestedCheckboxTreeNodePropType.children = PropTypes.arrayOf(NestedCheckboxTreeNodePropType).isRequired;
